// src/config/aws-config.js
import { Amplify } from 'aws-amplify';
import awsconfig from '../aws-exports'; // This is generated by Amplify CLI

Amplify.configure(awsconfig);

export default Amplify;
